export var billingTranslations = {
  'en': {
    'billingAcceptButtonText': 'Accept',
    'addButtonText': 'Add',
    'allPaymentsTopLabel': 'Select a Payment Method',
    'selectedPaymentTopLabel': 'Payment Methods',
    'areYouSureMessage': 'Are you sure you want to delete this payment method?',
    'billingCancelButtonText': 'Cancel',
    'cardTypeDropdownLabel': 'Add Payment',
    'defaultErrorMessage': 'The application was unable to complete your request.',
    'deleteModalHeader': 'Delete Payment Method',
    'editBillingButtonText': 'Edit Billing',
    'editPaymentText': 'Edit',
    'billingSaveChangesText': 'Save changes',
    'topLabelText': 'BILLING',
    'useThisPaymentButtonText': 'Use this payment method',
    'expirationModalContentTop': 'OUR RECORDS INDICATE THAT THE CREDIT CARD YOU USE TO PROCESS YOUR MONTHLY ADR ORDER IS DUE TO EXPIRE SOON.',
    'expirationModalContentBottom': 'In order to ensure that you continue receiving your monthly ADR shipment, simply update your credit card information under the billing section on the ADR Manage page. This will ensure that you always get your favorite products on time each month, giving you one less thing to worry about.',
    'expirationModalEditBillingButtonText': 'Update Now',
    'expirationModalCancelText': 'Update Later',
    'expiredButtonText': 'Payment method expired',
    'expiringSoonButtonText': 'Payment method expiring soon'
  },
  'zh': {
    'billingAcceptButtonText': '接受',
    'addButtonText': '添加',
    'allPaymentsTopLabel': '选择付款方式',
    'selectedPaymentTopLabel': '支付方式',
    'areYouSureMessage': '您确定要删除此付款方式吗?',
    'billingCancelButtonText': '取消',
    'cardTypeDropdownLabel': '添加付款方式',
    'defaultErrorMessage': '该应用程序无法完成您的请求。',
    'deleteModalHeader': '删除付款方式',
    'editBillingButtonText': '修改结算',
    'editPaymentText': '编辑',
    'billingSaveChangesText': '保存',
    'topLabelText': '付款信息',
    'useThisPaymentButtonText': '使用此付款方式',
    'expirationModalContentTop': '我们的记录显示您使用的信用卡处理您的每月ADR订单是由于即将到期',
    'expirationModalContentBottom': '为了确保您继续收到每月ADR货件，只需在ADR Manage页面的账单部分下更新您的信用卡信息即可。 这将确保您每个月都能按时准时收到您最喜爱的产品，从而为您减少一件担心的事情。',
    'expirationModalEditBillingButtonText': '立即更新',
    'expirationModalCancelText': '稍后更新',
    'expiredButtonText': '付款方式已过期',
    'expiringSoonButtonText': '付款方式即将到期'
  },
  'es': {
    'billingAcceptButtonText': 'Aceptar',
    'addButtonText': 'Añadir',
    'allPaymentsTopLabel': 'Seleccione un método de pago',
    'selectedPaymentTopLabel': 'Métodos de pago',
    'areYouSureMessage': '¿Está seguro de que quiere eliminar esta forma de pago?',
    'billingCancelButtonText': 'Cancelar',
    'cardTypeDropdownLabel': 'Agregar pago',
    'defaultErrorMessage': 'La aplicación no pudo completar su solicitud.',
    'deleteModalHeader': 'Eliminar Forma de pago',
    'editBillingButtonText': 'Editar facturación',
    'editPaymentText': 'Editar',
    'billingSaveChangesText': 'Guardar cambios',
    'topLabelText': 'FACTURACIÓN',
    'useThisPaymentButtonText': 'Utilice este método de pago',
    'expirationModalContentTop': 'NUESTROS REGISTROS INDICAN QUE LA TARJETA DE CRÉDITO USADA PARA PROCESAR SU ORDEN ADR MENSUAL SE DEBE EXPIRAR PRONTO.',
    'expirationModalContentBottom': 'Para garantizar que continúe recibiendo su envío ADR mensual, simplemente actualice la información de su tarjeta de crédito en la sección de facturación en la página ADR Manage. Esto asegurará que siempre obtenga sus productos favoritos a tiempo cada mes, y le dará una cosa menos de la que preocuparse.',
    'expirationModalEditBillingButtonText': 'Actualizar ahora',
    'expirationModalCancelText': 'Actualizar más tarde',
    'expiredButtonText': 'Método de pago vencido',
    'expiringSoonButtonText': 'El método de pago expira pronto'
  }
};
